import styles from "./CompanyAssessments.module.css";

interface TextAnswerFieldProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    placeholder?: string;
}

export function TextAnswerField({
    value,
    onChange,
    disabled = false,
    placeholder
}: TextAnswerFieldProps) {
    return (
        <textarea
            className={styles.dialogTextarea}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={event => onChange(event.target.value)}
        />
    );
}
